import React from 'react';

// Components
import EmptySearchResults from '@/views/components/data/DataTableV2/EmptySearchResults';
import SecondaryLink from '@/views/components/buttons/SecondaryLink';

// Libraries
import { FormattedMessage } from 'react-intl';

type Props = {
  searchQuery?: string;
  onAddContact: () => void;
};

const ContactsPageNoData = ({ searchQuery, onAddContact }: Props) => {
  const i18nTypeEmptyTable = !searchQuery ? 'NoData' : 'NoResults';
  const i18nEmptyTablePath = `Contacts.${i18nTypeEmptyTable}`;

  return (
    <div className="empty-contacts">
      {searchQuery && (
        <EmptySearchResults searchQuery={searchQuery} titleToLocalize={`${i18nEmptyTablePath}.Title`} messageToLocalize={`${i18nEmptyTablePath}.Message`} />
      )}
      {!searchQuery && (
        <SecondaryLink className="add-contact-link" onClick={onAddContact}>
          <FormattedMessage id="Contacts.NoData.GetStarted" />
          <i className="icon-arrow-up-right2" />
        </SecondaryLink>
      )}
    </div>
  );
};

export default ContactsPageNoData;
